angular.module('mercury.modules.settings.company')
.factory('Outlets', ["$http", "$q", "$resource", "settings", function($http, $q, $resource, settings) {
  var Outlets = $resource(settings.apiHost + '/r/CompanyOutlets');

  /**
   * Get the all outlets associated with a Company
   *
   * @memberof Outlets
   * @param  {String} id Id of the company
   */
  function Get() {
    return Outlets.query();
  }

  /**
   * Get the all outlets associated with a Company
   *
   * @memberof Outlets
   * @param  {String} id Id of the company
   */
  function GetAvailable(id) {
    var deferred = $q.defer();

    $http.get(settings.apiHost + '/r/ImportedOutlets/', {headers: {'x-loaded-company-id': id}})
    .then(function(response) {
      deferred.resolve(response.data);
    }, function(response) {
      deferred.reject(response);
    });

    return deferred.promise;
  }

  function Add(companyId, outlet) {

    var bindingModel = {
      companyId: companyId,
      outletId: outlet.outletId
    };
    return Outlets.save(bindingModel).$promise;
  }

  function Delete(outlet) {
    return Outlets.delete({companyOutletId: outlet.companyOutletId}).$promise;
  }

  return {
    get: Get,
    getAvailable: GetAvailable,
    add: Add,
    delete: Delete
  };
}]);
